import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupExclude: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"boolean-group-exclude"} maskId="square-filled-radius-0-stroke-1-IconBooleanGroupExclude"><path fillRule="evenodd" clipRule="evenodd" d="M16 16H22V2H8V8H2V22H16V16ZM8 8H16V16H8V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooleanGroupExclude;
